<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="巡演ID" :value="3"></el-option>
                            <el-option label="巡演名称" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activityPush/aggregatePush')" type="primary" size="small"
                :disabled="activityList.length < 1" @click="batchPush()">巡演聚合推送</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="activityName" label="演出名称" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="tourId" label="巡演ID"></el-table-column>
                <el-table-column prop="tourName" label="巡演名称" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="auditorTime" label="通过审核时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/activityPush/push')" type="text" size="small"
                            @click="singlePush(scope.row)">推送</el-button>
                        <el-button v-if="$utils.have('/activityPush/delete')" type="text" size="small"
                            @click="deleteEvent(scope.row.activityId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <push-msg ref="pushMsg" @onUpdate="getDataList"></push-msg>
    </div>
</template>
<script>
import pushMsg from './components/pushMsg';
const defaultParams = {
    pageNo: 1,
    queryType: 1,
    queryValue: ""
}
export default {
    components: { pushMsg },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || "",
            },
            listLoading: true,
            activityList: [],
            thisObj: {},
			singleObj:null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activityPush/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.activityList = val

        },
		singlePush(obj){
			this.singleObj = obj
			this.$request({
			    url: "/msg/push/checkActivityMessage",
			    method: "POST",
			    params: {activityId:obj.activityId },
			})
			    .then((res) => {
			        const { state, msg , result } = res.data;
			        if (state == 1 && result == 0) {
			           this.pushEvent()
			        } else {
			           const _html = "<div>\
			               <div style='font-weight:700'>该演出在24h内已经被推送过</div>\
			               <div>鉴于短时间内推送相同内容会<span class='color-danger'>导致用户关闭推送</span>，使推送内容无法触达粉丝，本次推送将<span class='color-danger'>不会对已收到相同推送的用户下发</span></div>\
			           	</div>"
						this.$confirm(_html, '', {
						    dangerouslyUseHTMLString: true,
							confirmButtonText: '确定推送',
							cancelButtonText: '取消',
						}).then(() => {
						    this.pushEvent()
						}).catch(() => {
							
						})
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
		},
        //推送事件
        pushEvent() {
			console.log(typeof(obj))
			//return
            if (this.singleObj.tourId) {
                this.$request({
                    url: "/activityPush/tourInfo",
                    method: "POST",
                    params: {
                        activityId: this.singleObj.activityId,
                        tourId: this.singleObj.tourId,
                        num: 1
                    },
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1) {
                            if (result === true) {
                                this.$confirm('还有同一巡演下其他演出待推送，是否需要选择聚合推送？', '推送', {
                                    confirmButtonText: '直接推送当前演出',
                                    cancelButtonText: '返回选择更多演出',
                                    center: true,
                                }).then(() => {
                                    this.$refs.pushMsg.show(this.singleObj.activityId, this.singleObj.activityName, '')
                                }).catch(() => {

                                })
                            } else {
                                this.$confirm('是否确认推送当前演出？', '推送', {
                                    confirmButtonText: '确认',
                                    cancelButtonText: '取消',
                                    center: true,
                                }).then(() => {
                                    this.$refs.pushMsg.show(this.singleObj.activityId, this.singleObj.activityName, '')

                                }).catch(() => {

                                })
                            }
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            } else {
                this.$confirm('是否确认推送当前演出？', '推送', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    center: true,
                }).then(() => {
                    this.$refs.pushMsg.show(this.singleObj.activityId, this.singleObj.activityName, '')

                }).catch(() => {

                })
            }

        },
        batchPush(){
			var _activityId = ""
			this.activityList.map(v => {
				if (v.tourId) {
					_activityId = v.activityId;					
				}
			})
			this.$request({
			    url: "/msg/push/checkActivityMessage",
			    method: "POST",
			    params: {activityId:_activityId },
			})
			    .then((res) => {
			        const { state, msg , result } = res.data;
			        if (state == 1 && result == 0) {
			           this.aggregatePush()
			        } else {
			           const _html = "<div>\
			               <div style='font-weight:700'>该演出在24h内已经被推送过</div>\
			               <div>鉴于短时间内推送相同内容会<span class='color-danger'>导致用户关闭推送</span>，使推送内容无法触达粉丝，本次推送将<span class='color-danger'>不会对已收到相同推送的用户下发</span></div>\
			           	</div>"
						this.$confirm(_html, '', {
						    dangerouslyUseHTMLString: true,
							confirmButtonText: '确定推送',
							cancelButtonText: '取消',
						}).then(() => {
						    this.aggregatePush()
						}).catch(() => {
							
						})
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
		},
        //聚合推送
        aggregatePush() {
            if (this.activityList.length < 2) {
                return this.$message.error('请至少勾选两个需要推送的演出');
            }

            let _tourId = "", _activityId = "", _tourFlag = true;
            this.activityList.map(v => {
                if (v.tourId) {
                    _tourId = v.tourId;
                    _activityId = v.activityId;
					
                }else{
                    _tourFlag = false;
                }
            });
            if( !_tourFlag ){
                return this.$message.error('所选演出不属于同一个巡演，无法聚合推送');
            }
            if (!_tourId) {
                this.$refs.pushMsg.show('', '', this.activityList)
            } else {
                this.$request({
                    url: "/activityPush/tourInfo",
                    method: "POST",
                    params: {
                        activityId: _activityId,
                        tourId: _tourId,
                        num: this.activityList.length
                    },
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1) {
                            if (result === true) {
                                this.$confirm('还有同一巡演下其他演出待推送，是否继续推送？', '推送', {
                                    confirmButtonText: '直接推送当前演出',
                                    cancelButtonText: '返回选择更多演出',
                                    center: true,
                                }).then(() => {

                                    let _tourIds = this.activityList.map(v => v.tourId);
                                    let _ntourIds = (Array.from(new Set(_tourIds))).filter(v => v !== undefined);

                                    if (this.activityList.length > 1 && (_tourIds.length !== this.activityList.length || _ntourIds.length !== 1)) {
                                        return this.$message.error('所选演出不属于同一个巡演，无法聚合推送');
                                    }
                                    if (this.activityList.length > 1) {
                                        this.$confirm('将按巡演整合推送1条信息给乐迷，是否推送', '巡演聚合推送', {
                                            confirmButtonText: '确认推送',
                                            cancelButtonText: '取消',
                                            center: true,
                                        }).then(() => {
                                            this.$refs.pushMsg.show('', '', this.activityList)
                                        }).catch(() => {

                                        })
                                    }

                                }).catch(() => {

                                })
                            } else {
                                let _tourIds = this.activityList.map(v => v.tourId);
                                let _ntourIds = (Array.from(new Set(_tourIds))).filter(v => v !== undefined);

                                if (this.activityList.length > 1 && (_tourIds.length !== this.activityList.length || _ntourIds.length !== 1)) {
                                    return this.$message.error('所选演出不属于同一个巡演，无法聚合推送');
                                }
                                if (this.activityList.length > 1) {
                                    this.$confirm('将按巡演整合推送1条信息给乐迷，是否推送', '巡演聚合推送', {
                                        confirmButtonText: '确认推送',
                                        cancelButtonText: '取消',
                                        center: true,
                                    }).then(() => {
                                        this.$refs.pushMsg.show('', '', this.activityList)
                                    }).catch(() => {

                                    })
                                }

                            }
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
            }

        },
        aggregatePushAction() {
            this.$request({
                url: "/activityPush/aggregatePush",
                method: "POST",
                params: {
                    activityIds: (this.activityList.map(v => v.activityId)).toString(),
                    num: this.activityList.length
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.getDataList();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
        },
        //删除
        deleteEvent(id) {
            this.$confirm('是否确认删除？删除以后，无法再对该演出进行上线推送', '删除', {
                center: true,
            }).then(() => {
                this.$request({
                    url: "/activityPush/delete",
                    method: "POST",
                    params: {
                        activityId: id
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {

            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>